module.exports = __webpack_public_path__ + "img/Group24.9674e69c.png";